import SEO from "../components/SEO";

const COMPANY = {
  name: "Trädfällarna Laholm AB",
  org: "559366-8576",
  address: "Mellby 420, 312 96 Laholm",
  email: "joakim@tradfallarna.nu",
  phone: "070 342 21 62",
};

const UPDATED = "Februari 2026";

function H2({ children }) {
  return (
    <h2 className="mt-10 mb-3 font-heading text-2xl font-extrabold text-[#1B2A1E]">
      {children}
    </h2>
  );
}

function P({ children }) {
  return (
    <p className="text-[#3a4338] text-base leading-relaxed mb-3">{children}</p>
  );
}

function Bullets({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5 mb-3 text-[#3a4338] leading-relaxed">
      {items.map((i, idx) => (
        <li key={idx}>{i}</li>
      ))}
    </ul>
  );
}

export default function Integritetspolicy() {
  return (
    <>
      <SEO
        title="Integritetspolicy | Trädfällarna Laholm AB"
        description="Så hanterar Trädfällarna Laholm AB personuppgifter från offertförfrågningar och kundkontakt. Information enligt GDPR."
        path="/integritetspolicy"
      />

      <section className="section-pad bg-[#F7F5F0]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Information</span>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold text-[#1B2A1E] leading-tight tracking-tight">
            Integritetspolicy
          </h1>
          <p className="mt-4 text-[#5A6258] text-sm">Senast uppdaterad: {UPDATED}</p>

          <div className="mt-8" data-testid="integritetspolicy-content">
            <P>
              Den här sidan förklarar hur Trädfällarna Laholm AB hanterar
              personuppgifter när du kontaktar oss eller skickar in en
              offertförfrågan via webbplatsen. Vi försöker hålla det enkelt och
              tydligt.
            </P>

            <H2>1. Personuppgiftsansvarig</H2>
            <P>
              <strong>{COMPANY.name}</strong>
              <br />
              Org.nr {COMPANY.org}
              <br />
              {COMPANY.address}
              <br />
              E-post:{" "}
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-[#D95D2E] hover:underline"
              >
                {COMPANY.email}
              </a>
              <br />
              Telefon:{" "}
              <a
                href={`tel:+46${COMPANY.phone.replace(/\D/g, "").slice(1)}`}
                className="text-[#D95D2E] hover:underline"
              >
                {COMPANY.phone}
              </a>
            </P>

            <H2>2. Vilka uppgifter vi kan samla in</H2>
            <P>När du fyller i offertformuläret eller kontaktar oss kan vi ta emot:</P>
            <Bullets
              items={[
                "Namn",
                "Telefonnummer",
                "E-postadress",
                "Adress eller ort",
                "Beskrivning av uppdraget",
                "Bilder som du laddar upp via offertformuläret",
                "Annan information du själv skriver i meddelandefältet",
              ]}
            />

            <H2>3. Varför vi samlar in uppgifterna</H2>
            <Bullets
              items={[
                "För att kunna svara på din offertförfrågan",
                "För att kunna bedöma uppdraget och föreslå rätt lösning",
                "För att kunna kontakta dig kring förfrågan eller arbetet",
                "För att administrera inkomna förfrågningar",
                "För att kunna följa upp kunddialogen",
              ]}
            />

            <H2>4. Hur uppgifterna hanteras</H2>
            <Bullets
              items={[
                "Uppgifterna sparas i webbplatsens databas och tillhörande adminvy.",
                "Uppgifterna kan skickas via e-post till ansvarig mottagare hos oss när du gör en förfrågan.",
                "Uppgifterna delas inte vidare för marknadsföring.",
                "Uppgifterna används enbart för att hantera din förfrågan och vår kontakt med dig.",
              ]}
            />

            <H2>5. Tredjepartstjänster</H2>
            <P>
              Webbplatsen drivs med hjälp av ett antal tekniska leverantörer för
              drift, hosting, säkerhet och e-postleverans. Det kan exempelvis
              handla om:
            </P>
            <Bullets
              items={[
                "Hosting- och driftleverantör för webbplats och databas",
                "Säkerhets- och prestandatjänst (t.ex. Cloudflare eller motsvarande, om det används)",
                "E-postleverans när offertförfrågan skickas (t.ex. Resend eller motsvarande, om det används)",
              ]}
            />
            <P>
              Dessa leverantörer behandlar uppgifter enbart i syfte att leverera
              tjänsten åt oss och får inte använda informationen för egna ändamål.
            </P>

            <H2>6. Hur länge uppgifter sparas</H2>
            <P>
              Vi sparar uppgifterna så länge det behövs för att hantera din
              förfrågan, för att kunna följa upp en pågående eller framtida
              kundrelation, eller för att uppfylla administrativa krav som vi
              omfattas av (t.ex. bokföring). När uppgifterna inte längre behövs
              tar vi bort dem.
            </P>

            <H2>7. Dina rättigheter</H2>
            <P>
              Du har rätt att kontakta oss och begära information om vilka
              uppgifter vi har om dig, rätta felaktiga uppgifter eller begära att
              uppgifterna raderas. Hör av dig till{" "}
              <a
                href={`mailto:${COMPANY.email}`}
                className="text-[#D95D2E] hover:underline"
              >
                {COMPANY.email}
              </a>{" "}
              så hjälper vi dig.
            </P>

            <H2>8. Frågor</H2>
            <P>
              Har du frågor om hur vi hanterar dina personuppgifter eller om den
              här sidan är du välkommen att kontakta oss.
            </P>
          </div>
        </div>
      </section>
    </>
  );
}
